import fallbackLabels from 'i18n/en_GB.utf8';
import { importLocale } from './locales';

function applyReplacements(translation, replacements) {
    if (!replacements) return translation;

    return Object.entries(replacements).reduce(
        (haystack, [needle, replacement]) => {
            const needleRegExp = new RegExp(`\\[${needle}\\]`, 'gi');
            return haystack.replace(needleRegExp, replacement);
        },
        translation
    );
}

function createNoLabelI18n(locale) {
    return (label) => {
        console.warn(`No labels were found for '${locale}' locale`);
        return label;
    };
}

export function createTranslate(mainLanguage, logger) {
    if (!logger) {
        throw new Error('Error: a logger is required');
    }

    return function translate(label, replacements) {
        if (!label || label === '') {
            throw new Error('Error: Must indicate a label.');
        }

        let translation = mainLanguage[label];

        if (!translation) {
            logger.warn(`Error: translation for label "${label}" not found`);
            translation = label;
        }

        return applyReplacements(translation, replacements);
    };
}

const translators = {
    current: null,
    navigator: null,
    fallback: createTranslate(fallbackLabels.global, console),
    noop: createNoLabelI18n('en_GB'),
};

async function setupTranslator(localeISO3166, translatorName) {
    try {
        const { default: labels } = await importLocale(localeISO3166);
        translators[translatorName] = createTranslate(labels.global, console);
    } catch (e) {
        /* empty */
    }
}

export const setLanguage = (localeISO3166, navigatorLocale) => {
    setupTranslator(localeISO3166, 'current');
    if (navigatorLocale) {
        setupTranslator(navigatorLocale, 'navigator');
    }
};

function narrowTranslators(translatorNames) {
    const narrowed = Object.entries(translators)
        .filter(([name]) => translatorNames.includes(name))
        .map(([, translator]) => translator);

    return (...args) =>
        narrowed.filter((translator) => translator !== null)[0](...args);
}

export const i18n = narrowTranslators(['current', 'fallback', 'noop']);
export const i18nNavigator = narrowTranslators([
    'navigator',
    'fallback',
    'noop',
]);
